<template>
  <div class="newCloudPhone pointer">
    <div class="titleBox">
      <NavBar title="续费云手机"></NavBar>
    </div>
    <div class="wrapper solveBfc contentBox">
      <div class="packageSelection">
        <div class="packageHead">
          {{ renewList[0].vipName }} {{ renewList[0].deviceVersionName }}/{{
            getAliasText(renewList[0].channelCode)
          }}
        </div>
        <renewSetMeal
          :packageList="packageList"
          :commodityActive="commodityActive"
          @commodityChange="commodityChange"
        ></renewSetMeal>
      </div>
      <div class="PayTypeAmountBox solveBfc">
        <PayTypeAmount
          :combo="packageList[commodityActive]"
          :count="count"
          :payType="payType"
          :renewIdList="getRenewIds(this.renewList)"
          @handleChange="handleStepperChange"
          @handlePayTypeChange="handlePayTypeChange"
          :isStepper="false"
        ></PayTypeAmount>
      </div>
      <div class="agreementBox">
        <img class="hint2" src="@/assets/icons/hint2.png" alt="" />
        <div>在购买前请阅读</div>
        <div class="hyperlink" @click="toAgreement">《会员服务协议》</div>
      </div>
    </div>
    <div class="baseBox">
      <div class="totalPricesBox">
        <div class="name">订单价</div>
        <div class="salePrice">
          <div class="span1">¥</div>
          <div class="span2">
            {{ (combo.salePrice * count * renewList.length).toFixed(2) }}
          </div>
        </div>
      </div>
      <van-button class="confirmPayment" @click="orderAffirmShow = true"
        >确认支付</van-button
      >
    </div>
    <van-action-sheet
      class="orderAffirmPopup pcPopup"
      v-model="orderAffirmShow"
    >
      <div class="content">
        <div class="card_1">
          <div class="titleBox">
            <div class="titleName">订单确认</div>
            <div class="close" @click="orderAffirmShow = false">
              <img src="@/assets/icons/popupClose.png" alt="" />
            </div>
          </div>
        </div>
        <div class="slideContent">
          <div class="card_2">
            <div class="card_2_left">{{ handleCombo(combo).packageName }}</div>
            <div class="card_2_right">
              <span class="sp1">{{
                ` ¥ ${handleCombo(combo).originPrice.toFixed(2)} /台`
              }}</span>
              <span class="sp2">{{
                ` 到手价 ¥ ${handleCombo(combo).salePrice.toFixed(2)} /台`
              }}</span>
            </div>
          </div>
          <div class="card_3" v-if="combo.batchPackageList.length > 0">
            <div class="card_3_top">
              <div>阶梯单价</div>
              <div>数量区间</div>
            </div>
            <div class="card_3_bottom">
              <div
                v-for="(item, index) in combo.batchPackageList"
                :key="index"
                :class="[
                  'card_3_bottom_item',
                  count >= item.minCount && count <= item.maxCount
                    ? 'sectionActive'
                    : '',
                ]"
                @click="handleBatchPackage(item.minCount, item.maxCount)"
              >
                <div class="priceBox">
                  <div class="salePrice">
                    <div class="span1">¥</div>
                    <div class="span2">{{ item.salePrice.toFixed(2) }}</div>
                  </div>
                  <div class="avgPrice">
                    {{ ` ¥ ${item.avgPrice.toFixed(2)} /天` }}
                  </div>
                </div>
                <div class="sectionBox">
                  {{ `${item.minCount} ≤ 购买数量 ≤ ${item.maxCount}` }}
                </div>
              </div>
            </div>
          </div>
          <div class="card_4">
            <PayTypeAmount
              :combo="packageListItems(packageList, commodityActive)"
              :count="count"
              :payType="payType"
              @handleChange="handleStepperChange"
              @handlePayTypeChange="handlePayTypeChange"
              :isStepper="true"
            ></PayTypeAmount>
          </div>
        </div>
        <div class="baseContent">
          <div class="base_discounts">
            <div class="base_left">共计{{ count }}台</div>
            <div class="base_left">
              已优惠：{{
                (
                  (handleCombo(combo).originPrice -
                    handleCombo(combo).salePrice) *
                  count *
                  renewList.length
                ).toFixed(2)
              }}
            </div>
          </div>
          <div class="base_actuallyPaid" @click="getordercreate">
            确认支付 ¥{{
              (handleCombo(combo).salePrice * count * renewList.length).toFixed(
                2
              )
            }}
          </div>
        </div>
      </div>
    </van-action-sheet>
    <van-action-sheet
      class="infoRderNoPopup pcPopup"
      v-model="rderNoResultShow"
      :close-on-click-overlay="false"
    >
      <div class="content">
        <div class="close" @click="payClose">
          <img src="@/assets/icons/popupClose.png" alt="" />
        </div>
        <img
          v-if="pay_obj.orderStatus == 'SUCCESS'"
          class="payImg"
          src="@/assets/imgs/paySucceed.png"
          alt=""
        />
        <img v-else class="payImg" src="@/assets/imgs/payFail.png" alt="" />
        <div class="totalAmount">
          <span>{{
            pay_obj.orderStatus == "SUCCESS" ? "支付成功" : "支付失败"
          }}</span>
          <span> ¥ {{ pay_obj.totalAmount.toFixed(2) }}</span>
        </div>
        <div class="atPayType">{{ atPayType }}支付</div>
        <div class="toPlay" @click="payFinish">
          {{
            serviceShow
              ? "云手机分配异常点击联系客服"
              : pay_obj.orderStatus == "SUCCESS"
              ? "查看新购云手机"
              : "重新购买"
          }}
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
    
    <script>
import NavBar from "@/components/NavBar.vue";
import renewSetMeal from "@/components/buy/renewSetMeal.vue";
import PayTypeAmount from "@/components/buy/PayTypeAmount.vue";
import {
  packageversionListV2,
  ordercreate,
  infoRderNo,
  getopenId,
} from "@/api/buy";
import { sysConfigByConfigKey } from "@/api/index.js";
import { mapState, mapMutations } from "vuex";
import { Toast, Dialog } from "vant";
import Cookies from "js-cookie";
export default {
  name: "NewCloudPhone",
  components: {
    NavBar,
    renewSetMeal,
    PayTypeAmount,
  },
  data() {
    return {
      modelActive: 0,
      versionList: [{ productVersionVos: [{ packageList: [] }] }],
      supplierList: [],
      // 厂商
      supplierActive: 0,
      //   版本
      versionsActive: 0,
      // 商品
      commodityActive: 0,
      // 查看更多
      intCount: 2,
      showAll: false,
      count: 1,
      payType: 5,
      combo: {
        salePrice: 0,
        originPrice: 0,
        avgPrice: 0,
        batchPackageList: [],
      },
      orderAffirmShow: false,
      serviceShow: false,
      rderNoResultShow: false,
      atPayType: "微信",
      pay_obj: { totalAmount: 0 },
      packageList: [],
      aliasOptions: [
        {
          label: "B",
          value: "baidu",
        },
        {
          label: "S",
          value: "huoshan",
        },
        {
          label: "Z",
          value: "intelligent",
        },
        {
          label: "H",
          value: "huawei",
        },
      ],
      openld: null,
    };
  },
  mounted() {
    this.getPackageversionList();
    this.getInfoRderNo();
    // 本地存储避免多次请求code报错
    let openIdCookies = Cookies.get("openid");
    if (!openIdCookies || openIdCookies == 0) {
      this.getCode();
    } else {
      this.openld = openIdCookies;
    }
  },
  beforeDestroy() {},

  methods: {
    ...mapMutations("perpetual", ["SET_RENEWLIST"]),
    // 获取code
    async getCode() {
      var str = this.$route.query.code;
      if (str) {
        let data = {
          code: str,
        };
        // 走后端接口(把code传给后台，让后台根据code获取openID与用户信息) 通过code 获取openid
        await getopenId(data).then((res) => {
          if (res.code == 200) {
            this.openld = res.msg;
            Cookies.set("openid", res.msg);
          } else {
            Toast("获取失败！");
          }
        });
      } else {
        if (
          typeof WeixinJSBridge === "object" &&
          typeof WeixinJSBridge.invoke === "function"
        ) {
          var appid = "wx909fcb382f6004ca";
          var redirect_uri = window.location.href;
          var newRedirect = encodeURIComponent(redirect_uri); // 此处需要将你的回调页面进行转码，此方法直接使用
          location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appid +
            "&redirect_uri=" +
            newRedirect +
            "&response_type=code&scope=snsapi_userinfo&state=333&connect_redirect=1#wechat_redirect";
        }
      }
    },
    // 获取云手机套餐
    async getPackageversionList() {
      let that = this;
      let data = {
        vipCode: this.renewList[0].vipCode,
        deviceVersionCode: this.renewList[0].deviceVersionCode,
        renewIds: this.getRenewIds(this.renewList),
        channelCode: this.renewList[0].channelCode,
      };
      await packageversionListV2(data).then((res) => {
        if (res.code == 200) {
          that.versionList = customSort(res.data);
          function customSort(arr) {
            arr.forEach((item) => {
              item.productVersionVos.forEach((list) => {
                list.packageList.forEach((code, index) => {
                  code.overallMminCount = code.minCount;
                  // 阶梯价格排序
                  code.batchPackageList.sort((a, b) => {
                    return a.minCount - b.minCount;
                  });
                  // 阶梯价格最小价格
                  if (code.batchPackageList.length > 0) {
                    let findItem =
                      code.batchPackageList[code.batchPackageList.length - 1];
                    findItem.batchPackageList = code.batchPackageList;
                    findItem.overallMminCount = code.overallMminCount;
                    that.$set(list.packageList, index, findItem);
                  }
                });
              });
            });
            return arr;
          }
          this.packageList =
            that.versionList[0].productVersionVos[0].packageList;
          this.valuationCount();
        } else {
          if (res.msg == "请使用激活码续费" && res.code == 500) {
            Dialog.confirm({
              title: "提示",
              message: "定制版请前往激活码续费",
              confirmButtonText: "去激活码页面",
              cancelButtonText: "返回首页",
              confirmButtonColor: "#8572eb",
            })
              .then(() => {
                this.$router.push({
                  path: "/activationcodeusage",
                  query: { type: 1 },
                });
              })
              .catch(() => {
                this.$router.push("/");
              });
          }
        }
      });
    },
    commodityChange(index) {
      if (this.commodityActive != index) {
        this.commodityActive = index;
        this.valuationCount();
      }
    },
    handleStepperChange(count) {
      this.count = count;
      // this.threeShiftTwo();
    },
    handlePayTypeChange(type) {
      if (this.payType != type) {
        this.payType = type;
      }
    },
    threeShiftTwo() {
      let data = this.packageList[this.commodityActive];
      if (data.batchPackageList.length > 0) {
        if (this.count < data.minCount || this.count > data.maxCount) {
          let findItem = data.batchPackageList.find(
            (item) => this.count >= item.minCount && this.count <= item.maxCount
          );
          if (findItem) {
            findItem.batchPackageList = data.batchPackageList;
            findItem.overallMminCount = data.overallMminCount;
            this.$set(packageList, commodityActive, findItem);
          }
        }
      }
    },
    valuationCount() {
      let data = this.packageList[this.commodityActive];
      this.count = data.overallMminCount;
    },
    // 创建订单并拉起支付
    getordercreate() {
      let that = this;
      let _payType = that.payType;
      if (that.payType != 6) {
        const isWeixinBrowser = /micromessenger/i.test(navigator.userAgent);
        if (isWeixinBrowser) {
          _payType = 7;
        } else {
          _payType = 5;
        }
      }
      let _combo = this.handleCombo(this.combo);
      if (_combo.id) {
        let data = {
          packageId: _combo.id,
          totalAmount: (
            _combo.salePrice *
            that.count *
            that.renewList.length
          ).toFixed(2),
          count: that.count,
          payType: _payType,
          renewIds: that.getRenewIds(that.renewList),
          skipUrl: process.env.VUE_APP_LOOK_URL + "/renewCloudPhone",
          openId: that.openld,
        };
        ordercreate(data).then((res) => {
          if (res.code == 200) {
            if (_payType == 6) {
              let div = document.querySelector("#payDiv");
              if (!div) {
                div = document.createElement("div");
                div.id = "payDiv";
                document.body.appendChild(div);
              }
              div.innerHTML = res.data.payUrl;
              document.forms[0].submit();
            }
            if (_payType == 5) {
              location.href =
                res.data.payUrl +
                `&redirect_url=${process.env.VUE_APP_LOOK_URL}/renewCloudPhone?payType=${res.data.orderNo}`;
            }
            if (_payType == 7) {
              that.onBridgeReady(res.data);
            }
          }
        });
      } else {
        Toast("请先选择套餐!");
      }
    },
    // 微信js支付专用
    onBridgeReady(params) {
      let data = {
        appId: "wx909fcb382f6004ca", //公众号名称，由商户传入
        timeStamp: params.timeStamp, //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: params.nonce, //支付签名随机串，不长于 32 位
        package: "prepay_id=" + params.prepayId, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: "RSA", //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: params.sign, //支付签名
        notify_url: "https://www.weixin.qq.com/wxpay/pay.php",
        amount: {
          total: params.totalAmount,
          currency: "CNY",
        },
      };
      WeixinJSBridge.invoke("getBrandWCPayRequest", data, function (res) {
        if (res.err_msg === "get_brand_wcpay_request:ok") {
          // this.$router.push({ path: "/resultpayment" });
          window.location.href = `${process.env.VUE_APP_LOOK_URL}/newCloudPhone?payType=${params.orderNo}`;
        } else if (res.err_msg === "get_brand_wcpay_request:fail") {
          Toast(res.err_msg);
        }
      });
    },
    handleCombo(list) {
      let findItem = list.batchPackageList.find(
        (item) => this.count >= item.minCount && this.count <= item.maxCount
      );
      if (findItem) {
        return findItem;
      } else {
        return list;
      }
    },
    getInfoRderNo() {
      let parameters = null;
      if (this.$route.query.out_trade_no) {
        parameters = this.$route.query.out_trade_no;
        this.atPayType = "支付宝";
      } else {
        parameters = this.$route.query.payType;
        this.atPayType = "微信";
      }
      if (!parameters) {
        return;
      }
      this.num++;
      infoRderNo(parameters).then((res) => {
        if (res.code == 200) {
          if (res.data.orderStatus == "SUCCESS") {
            this.pay_obj = res.data;
            if (res.data.instanceStatus == 2) {
              this.serviceShow = true;
            }
            this.rderNoResultShow = true;
          } else {
            this.setTime = setTimeout(() => {
              if (this.num <= 3) {
                this.getInfoRderNo();
              } else {
                this.pay_obj = res.data;
                this.rderNoResultShow = true;
              }
            }, 1000);
          }
        }
      });
    },
    payFinish() {
      if (this.serviceShow) {
        this.$router.push("/");
        sysConfigByConfigKey({ configKey: "wx_kf_url" }).then((res) => {
          if (res.code == 200) {
            window.location.href = `https://work.weixin.qq.com/kfid/${res.data}`;
          }
        });
      } else {
        if (this.pay_obj.orderStatus == "SUCCESS") {
          this.$router.push("/");
        } else {
          this.$router.push("/");
        }
      }
    },
    payClose() {
      this.$router.push("/");
    },
    toAgreement() {
      location.href = "http://static.aixunliu.com/app/vip.html";
    },
    handleBatchPackage(minCount, maxCount) {
      if (!(this.count >= minCount && this.count <= maxCount)) {
        this.count = minCount;
      }
    },
  },
  computed: {
    ...mapState("perpetual", ["renewList"]),
    packageListItems: {
      get() {
        return function (list, index) {
          let data = list[index];
          if (data) {
            // this.count = data.minCount;
            this.combo = data;
          }
          return data;
        };
      },
    },
    getRenewIds: {
      get() {
        return function (list) {
          let ids = list.map((item) => item.id);
          return ids;
        };
      },
    },
    getAliasText: {
      get() {
        return function (status) {
          let item = this.aliasOptions.find((item) => item.value == status);
          if (item) {
            return item.label;
          } else {
            return "X";
          }
        };
      },
    },
  },
};
</script>
    
    <style lang="less" scoped>
.newCloudPhone {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.titleBox {
  padding: 0 10px;
}

.contentBox {
  font-family: MiSans, MiSans;
  padding: 10px 10px 12px 10px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation !important;
  scrollbar-width: none;
  .wrapper {
    width: 100%;
    height: 100%;
  }
  .packageSelection {
    width: 100%;
    .packageHead {
      width: 100%;
      height: 42px;
      line-height: 42px;
      background: linear-gradient(180deg, #e6e6ff 0%, #ffffff 100%);
      border-radius: 10px 10px 0px 0px;
      font-weight: 600;
      font-size: 17px;
      color: #886df3;
    }
  }
  .PayTypeAmountBox {
    margin-top: 8px;
  }
  .agreementBox {
    font-weight: 500;
    font-size: 13px;
    color: #a9adb6;
    display: flex;
    align-items: center;
    padding: 17px 0 22px 0;
    .hint2 {
      width: 17px;
      height: 17px;
      margin-right: 8px;
    }
    .hyperlink {
      color: #a092eb;
    }
  }
}
.baseBox {
  width: 100%;
  height: 56px;
  background: #fff;
  border: 1px solid #f4f6fa;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 13px;
  .totalPricesBox {
    display: flex;
    align-items: center;
    .salePrice {
      display: flex;
      align-items: baseline;
      margin-left: 8px;
      .span1 {
        font-size: 13px;
        font-weight: 500;
        color: #8572eb;
        margin-right: 4px;
      }
      .span2 {
        font-size: 21px;
        font-weight: Bold;
        color: #8572eb;
      }
    }
  }
  .confirmPayment {
    width: 108px;
    height: 42px;
    background: #8572eb;
    border-radius: 21px;
    font-weight: 600;
    font-size: 15px;
    color: #ffffff;
  }
}
.orderAffirmPopup {
  max-height: 100%;
  .content {
    padding: 0 10px;
    background: #f5f7fb;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    max-height: 600px;
  }
  .card_1 {
    padding: 25px 0 13px 0;
    .titleBox {
      display: flex;
      justify-content: center;
      position: relative;
      padding: 0;
      .titleName {
        font-weight: 600;
        font-size: 17px;
        color: #222222;
      }
      .close {
        width: 25px;
        height: 25px;
        position: absolute;
        right: 11px;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 17px;
          height: 17px;
        }
      }
    }
  }
  .slideContent {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    touch-action: manipulation;
    scrollbar-width: none;
    .card_2 {
      width: 100%;
      height: 61px;
      background: #fff;
      border-radius: 13px;
      margin-top: 12px;
      padding: 0 17px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card_2_left {
        font-weight: 600;
        font-size: 15px;
        color: #505465;
      }
      .card_2_right {
        .sp1 {
          font-weight: 500;
          font-size: 13px;
          color: #a9adb6;
          margin-right: 8px;
          text-decoration: line-through;
        }
        .sp2 {
          font-weight: 500;
          font-size: 15px;
          color: #8572eb;
        }
      }
    }
    .card_3 {
      margin-top: 12px;
      .card_3_top {
        width: 354px;
        height: 46px;
        border-radius: 13px 13px 0 0px;
        background: #fff;
        padding: 0 17px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 500;
        font-size: 13px;
        color: #a9adb6;
      }
      .card_3_bottom {
        width: 100%;
        background: #ffffff;
        .card_3_bottom_item {
          width: 100%;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 17px;
          .priceBox {
            display: flex;
            .salePrice {
              display: flex;
              align-items: baseline;
              margin-right: 10px;
              .span1 {
                font-weight: 600;
                font-size: 13px;
                color: #505465;
                margin-right: 2px;
              }
              .span2 {
                font-weight: 600;
                font-size: 17px;
                color: #505465;
              }
            }
            .avgPrice {
              font-weight: 500;
              font-size: 10px;
              color: #67686e;
            }
          }
          .sectionBox {
            font-weight: 500;
            font-size: 13px;
            color: #67686e;
          }
        }
        .sectionActive {
          background: #f0edfe;
          .priceBox {
            .salePrice {
              .span1 {
                color: #8572eb;
              }
              .span2 {
                color: #8572eb;
              }
            }
            .avgPrice {
              color: #a092eb;
            }
          }
          .sectionBox {
            color: #a092eb;
          }
        }
      }
    }
    .card_4 {
      margin-top: 12px;
    }
  }
  .baseContent {
    padding: 25px 21px 31px 21px;
    .base_discounts {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;
      font-size: 13px;
      color: #505465;
    }
    .base_actuallyPaid {
      width: 100%;
      height: 42px;
      line-height: 42px;
      background: #886df3;
      border-radius: 267px;
      font-weight: 500;
      font-size: 15px;
      color: #fff;
      margin-top: 17px;
    }
  }
}
.infoRderNoPopup {
  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 31px;
    .close {
      width: 25px;
      height: 25px;
      position: absolute;
      right: 17px;
      top: 21px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 17px;
        height: 17px;
      }
    }
    .payImg {
      margin: 50px 0 31px;
      width: 92px;
      height: 92px;
    }
    .totalAmount {
      font-weight: 600;
      font-size: 19px;
      color: #505465;
    }
    .atPayType {
      font-weight: 500;
      font-size: 15px;
      color: #a9adb6;
      margin: 16px 0 25px 0;
    }
    .toPlay {
      width: 333px;
      height: 42px;
      line-height: 42px;
      background: #886df3;
      border-radius: 267px;
      font-weight: 500;
      font-size: 15px;
      color: #ffffff;
    }
  }
}
</style>